module.exports = require("@swa-ui/vacations/src/ALGTransitionBannerPlacement/ALGTransitionBannerPlacement.module.scss");